export default __webpack_public_path__ + "static/media/trash-2.8fba8bf6.svg";